module.exports = __webpack_public_path__ + "img/run-failed.b61ccbb.png";